import { useStyles } from '@webapps/styles';
import FiltersOrganismes from '../components/FiltersOrganismes';
import { Grid } from '@material-ui/core';
import RelationsCard from './RelationsCard';
import { Loader, PaginationNumbers } from '@webapps/reactjs-tech-components';
import Nodata from 'components/NoData';
import theme from '../theme';

const {
  images: { TrainingsImage }
} = theme

const Relations = ({ relationsList, relations, refetch, setPage, page, size, totalElements, formik, isLoading }) => {

  const { global, classes, css, cx } = useStyles();

  return (
    <div className={css({
      height: '100%',
      paddingBottom: (totalElements > 0) ? 'initial' : '50px'
    })}>
      <FiltersOrganismes formik={formik} schools={relationsList.map(item => item.school).filter(school => school)} refetch={refetch} type="relations" />
      <Grid className={cx(global.paper)} container>
        {
          isLoading ?
            ([...Array(size/2)].map((_, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }} >
                <RelationsCard isLoading={isLoading} info={{}} refetch={refetch} />
              </Grid>
            )))
            : relations?.length > 0 ? relations?.map((relation) => (
              <Grid key={relation.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: '0 20px 20px 0' }} >
                <RelationsCard info={relation} refetch={refetch} />
              </Grid>
            )) : (
              <Nodata
                contentWidth="20%"
                borderRadius='36px'
                padding="0px 20px 20px 0px"
                title="Aucun organisme de formation"
                description="Vous n'avez pas encore établi de relations avec des organismes de formation."
                image={TrainingsImage}
              />
            )}
      </Grid>
      {(relations?.length > 0) && (
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      )}
    </div>
  );
};

export default Relations;